import React from 'react';
import { Trophy, TrendingUp, TrendingDown, Users } from 'lucide-react';

export const OperatorLeaderboard = ({ 
  scores = [], 
  title = "Top Operatorlar",
  headerBgClass = "bg-blue-600"
}) => {
  return (
    <div className="bg-white rounded-lg border border-zinc-200 overflow-hidden mt-8">
      <div className={`${headerBgClass} p-4`}>
        <h2 className="text-2xl font-bold uppercase tracking-tight text-white flex items-center gap-2" data-testid="operator-leaderboard-title">
          <Users className="h-6 w-6" />
          {title}
        </h2>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-zinc-100 border-b border-zinc-200">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-bold text-zinc-700 uppercase tracking-wider">Sıra</th>
              <th className="px-6 py-3 text-left text-xs font-bold text-zinc-700 uppercase tracking-wider">Operator</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase tracking-wider">Xal</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase tracking-wider">Yaradılmış</th>
              <th className="px-6 py-3 text-center text-xs font-bold text-zinc-700 uppercase tracking-wider">Bağlanmış</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-zinc-200">
            {scores.map((score, index) => (
              <tr 
                key={score.operator_id} 
                className={index < 3 ? 'bg-blue-50' : ''}
                data-testid={`operator-row-${score.operator_id}`}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    {index === 0 && <Trophy className="h-5 w-5 text-yellow-500 mr-2" />}
                    {index === 1 && <Trophy className="h-5 w-5 text-zinc-400 mr-2" />}
                    {index === 2 && <Trophy className="h-5 w-5 text-amber-600 mr-2" />}
                    <span className="font-bold text-zinc-900">{index + 1}</span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="font-semibold text-zinc-900" data-testid={`op-name-${score.operator_id}`}>
                    {score.operator_full_name || score.operator_name}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <div className="flex items-center justify-center gap-1">
                    {score.score > 0 ? (
                      <TrendingUp className="h-4 w-4 text-green-600" />
                    ) : (
                      <TrendingDown className="h-4 w-4 text-red-600" />
                    )}
                    <span className={`text-xl font-bold font-mono ${
                      score.score > 0 ? 'text-green-600' : 'text-red-600'
                    }`} data-testid={`op-score-${score.operator_id}`}>
                      {score.score > 0 ? '+' : ''}{score.score}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <span className="text-blue-600 font-semibold" data-testid={`op-created-${score.operator_id}`}>
                    {score.tickets_created}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-center">
                  <span className="text-green-600 font-semibold" data-testid={`op-closed-${score.operator_id}`}>
                    {score.tickets_closed}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OperatorLeaderboard;
